import { logEvent } from '@/utils/analytics';
import { TextLink } from '@/components/TextLink';
import Events from '@/utils/amplitudeEvents.json';
import { MarkdownToJSX } from '@/components/MarkdownToJSX';

type TelephoneCardProps = {
  description?: string | null;
  identifier?: string | null;
  telephoneText?: string;
  telephoneLink: string;
  title: string;
};

export const TelephoneCard = ({ telephoneLink, telephoneText, description, identifier, title }: TelephoneCardProps) => {
  const handleClick = () => {
    let telephoneCategory = 'other';
    let categoryEventType = Events.TELEPHONE_CLICK;

    if (title === 'Call us') {
      telephoneCategory = 'main';
      categoryEventType = Events.TELEPHONE_CLICK_MAIN;
    } else if (title === 'Call us about your repayments') {
      telephoneCategory = 'financial_support';
      categoryEventType = Events.TELEPHONE_CLICK_FINANCIAL_SUPPORT;
    } else if (title === 'Call PayPlan') {
      telephoneCategory = 'payplan';
      categoryEventType = Events.TELEPHONE_CLICK_PAYPLAN;
    }

    const trackingData = {
      telephoneNumber: telephoneText,
      type: 'telephone-card',
      href: telephoneLink,
      telephoneCategory,
      cardTitle: title,
    };

    logEvent(categoryEventType, trackingData);
  };

  return (
    <div
      className="hover:scale-[1.02] bg-background transition-all relative border border-base-400 max-w-[768px] focus-within:ring-offset-background focus-within:ring-focused focus-within:ring-2 focus-within:ring-offset-2 rounded-lg text-left pt-6 flex px-6 mx-auto mb-5 md:mb-6"
      data-automation="ZA.button-telephone-card"
      id={identifier || undefined}
    >
      <div className="mr-5">
        <span className="material-symbols-outlined text-5xl!">phone</span>
      </div>
      <div>
        {title ? <span className="mb-2 font-serif block text-xl">{title}</span> : null}
        {telephoneText?.trim() ? <span className="mb-2 inline-block underline">{telephoneText}</span> : null}
        {description ? (
          <div>
            <MarkdownToJSX md={description} />
          </div>
        ) : null}
      </div>
      <TextLink
        aria-label={telephoneText?.trim() || title || 'Telephone link'}
        className="absolute left-0 top-0 bottom-0 right-0 outline-none"
        onClick={handleClick}
        href={telephoneLink}
      />
    </div>
  );
};
